<atx-business-contacts
  [contacts]="contacts$ | async"
  [hyperlinkEmail]="true"
  [showShowAllButton]="showShowAllButton"
  [isLoading]="isLoading$ | async"
  (showAll)="showAllClicked()"
></atx-business-contacts>
